import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ConfirmationTrainingEventCompletedModel } from '@evorait/pace-core';
import { FormArray } from '@angular/forms';

@Component({
    selector: 'pace-confirmation-training-event',
    templateUrl: './confirmation-training-event-completed.component.html',
    styleUrls: ['./confirmation-training-event-completed.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationTrainingEventCompletedComponent {
    @Input()
    public model: ConfirmationTrainingEventCompletedModel;

    @Input()
    public parentForm: FormArray;
}
